import { createFileRoute } from "@tanstack/react-router";
import { MfeMount } from "../presentational/MfeMount";
import { bootSettled } from "../shell-handle/bootGate";
import { permissionForRoute } from "../shared/components/sidebar/routePermissionRegistry";
import { PermissionType } from "../pages/Configuration/AdminConfiguration/Users/types/cognitoTypes";

export const Route = createFileRoute("/$")({
  beforeLoad: ({ location }) => {
    if (permissionForRoute(location.pathname) === PermissionType.Plan) {
      return bootSettled();
    }
  },
  component: MfeMount,
});
